import { Button, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { RootState } from 'store';
import { jbColors } from 'theme/jbColors';

export const ProductDetailsNavigateToTask = () => {
  const navigate = useNavigate();
  const selectedServiceAgreement = useSelector((state: RootState) => state.serviceAgreements.selectedServiceAgreement);

  // service role step metadata always contains one element corresponding to the task that is currently in progress, use stepMetadata not tasks
  const serviceRolesWithTasksInProgress =
    selectedServiceAgreement?.serviceRoles?.filter((sr) =>
      sr?.tasks?.find((t) => t !== undefined && t.resolution === 'In progress'),
    ) ?? [];

  return serviceRolesWithTasksInProgress && serviceRolesWithTasksInProgress.length > 0 ? (
    <Grid
      container
      data-testid="product-details-navigate-to-task-container"
      className="scrollbarThinContainer"
      sx={{
        display: 'flex',
        maxHeight: '15em',
        overflow: 'auto',
      }}
    >
      {serviceRolesWithTasksInProgress.map((serviceRole) => {
        const stepMetadata = serviceRole.stepMetadata && serviceRole.stepMetadata[0];
        const pendingTaskName = stepMetadata ? stepMetadata.taskName : '';
        const workAccess = stepMetadata ? stepMetadata.workAccess : false;

        const message = workAccess
          ? `There are pending tasks on a service role. Check the service role overview section or click here to navigate to the first task. ${pendingTaskName}`
          : `There are pending tasks on a service role, however, the required access to work on it is missing. ${pendingTaskName}`;

        return (
          <Grid
            key={serviceRole.serviceRoleUid}
            container
            sx={{
              padding: '1em',
              border: '1px solid blue',
              backgroundColor: '#EAF2FF',
              marginTop: '0.5em',
            }}
          >
            <Grid
              item
              xs={8}
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
              }}
            >
              <Grid>{message}</Grid>
            </Grid>
            <Grid
              item
              xs={4}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                flexDirection: 'row',
              }}
            >
              <Button
                data-testid="product-details-navigate-to-task"
                disabled={!workAccess}
                sx={{
                  border: '1px solid blue',
                  color: workAccess ? jbColors.core.reflexBlue[100] : 'grey',
                  backgroundColor: 'white',
                  '&:hover': {
                    color: workAccess ? 'white' : 'grey',
                    backgroundColor: workAccess ? jbColors.core.reflexBlue[100] : '#f0f0f0',
                  },
                }}
                onClick={() => navigate(`serviceRole/${serviceRole.serviceRoleUid}/details`)}
              >
                Navigate to task
              </Button>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  ) : null;
};
